/**
* @author Ryan Gladstone
*/

/* eslint-disable */

function analyticsService($q, $window, $log, $location, companyService) {
  const service = {};
  const thingsToTrack = {};

  function resetAnalyticsProperties() {
    // This is probably overkill as long as WebSked is single tenant
    // but to be on the safe side, we can reset the values anyway.
    service.isEnabled = false;
    service.alreadyInitialized = false;
    service.alreadyBooted = false;
    service.analyticsID = null;
  }
  resetAnalyticsProperties();


  function setAnalyticsID() {
    const host = $location.host();
    let propertyId;

    if (host.indexOf('localhost') > -1 || host.indexOf('sandbox') > -1 || host.indexOf('staging') > -1) {
      // Sandbox, Staging, or Localhost
      propertyId = 16;
    } else {
      // Production
      propertyId = 17;
    }

    return `UA-55373431-${propertyId}`;
  }


  service.checkIfEnabled = () => service.isEnabled;


  service.init = () => {
    const deferred = $q.defer();

    // This should run only once -- on bootstrap
    companyService.get()
      .then((company) => {
        service.isEnabled = true;
        service.analyticsID = setAnalyticsID();

        // Download and init the Google Analytics JS library
        // Google Analytics
        /**
         * Creates a temporary global ga object and loads analytics.js.
         * Parameters o, a, and m are all used internally. They could have been
         * declared using 'var', instead they are declared as parameters to save
         * 4 bytes ('var ').
         *
         * @param {Window}        i The global context object.
         * @param {HTMLDocument}  s The DOM document object.
         * @param {string}        o Must be 'script'.
         * @param {string}        g Protocol relative URL of the analytics.js script.
         * @param {string}        r Global name of analytics object. Defaults to 'ga'.
         * @param {HTMLElement}   a Async script tag.
         * @param {HTMLElement}   m First script tag in document.
         */
        (function (i, s, o, g, r, a, m) {
          i.GoogleAnalyticsObject = r; // Acts as a pointer to support renaming.

          // Creates an initial ga() function.
          // The queued commands will be executed once analytics.js loads.
          i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
          };

          // Sets the time (as an integer) this tag was executed.
          // Used for timing hits.
          i[r].l = 1 * new Date();

          // Insert the script tag asynchronously.
          // Inserts above current tag to prevent blocking in addition to using the
          // async attribute.
          a = s.createElement(o);
          m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        }(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga'));

        // Creates a default tracker with automatic cookie domain configuration.
        ga('create', service.analyticsID, 'auto');

        // End Google Analytics

        service.trackPageview();

        service.alreadyInitialized = true;
        deferred.resolve(company);
      }, (response) => {
        if (response && response.status && response.status !== 401) {
          $log.error('companyService.get() error: ', response);
        }
        deferred.reject(response);
      });

    return deferred.promise;
  };


  service.boot = () => {
    if (service.alreadyInitialized && service.isEnabled) {
      // if GA enabled
      service.trackPageview();
    } else if (!service.alreadyInitialized) {
      service.init();
    }
  };


  service.elapsedTimeStart = (target) => {
    thingsToTrack[target] = new Date().getTime();
  };


  service.elapsedTimeEnd = (target) => {
    const endTime = new Date().getTime();
    return endTime - thingsToTrack[target];
  };


  service.trackEvent = (eventCategory, eventAction) => {
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/events
    // console.log('service.trackEvent() ', eventCategory, eventAction);
    if ($window.ga && companyService.cache) {
      // For now, block tracking events if Google Analytics isn't attached to the window
      // or company service isn't yet cached.
      // In the future, we'll have a method which waits on a promise.
      ga('send', 'event', eventCategory, eventAction, companyService.cache.id);
    }
  };


  let lastTrackedURL;

  service.trackPageview = () => {
    if ($location.url() === lastTrackedURL) {
      // Has this URL already been tracked?
      // This blocks load more and auto refresh from triggering pageviews
      return;
    }

    lastTrackedURL = $location.url();
    if ($window.ga) {
      ga('send', 'pageview', $location.url());
    }
  };


  return service;
}

const serviceArray = [
  '$q',
  '$window',
  '$log',
  '$location',
  'companyService',
  analyticsService
];

module.exports = (ngModule) => {
  ngModule.service('analyticsService', serviceArray);
};
